module.exports = __webpack_public_path__ + "img/124.95307e3b.jpg";